import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../config.service';

@Injectable({
  providedIn: 'root',
})
export class CoreApiService {
  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService
  ) {}

  getVacancies<T>(payload: {
    clientCode: string;
    [key: string]: unknown;
  }): Observable<T> {
    const query = new URLSearchParams({ clientCode: payload.clientCode });
    const url = `${this.configService.getBffUrl(
      'core',
      'v2/integration/vacancySearch'
    )}?${query.toString()}`;
    return this.http.post<T>(url, payload);
  }

  getClientLanguages<T>(clientCode: string): Observable<T> {
    const query = new URLSearchParams({ clientCode });
    const url = `${this.configService.getBffUrl(
      'core',
      'metadata/clientLanguages'
    )}?${query.toString()}`;
    return this.http.get<T>(url);
  }
}
